import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/shared/components/ui/button';
import { Mail } from 'lucide-react';
import { useSpMessageLaunch } from '@/features/messaging/hooks/useSpMessageLaunch';
import type { NetworkProfessional } from '../api/networkApi';

type NetworkMessageButtonProps = {
  professional: NetworkProfessional;
};

/**
 * "My Network" row message CTA (ticket 07). SP connections route through the
 * shared launch gate; FA connections aren't SP-targeting, so they navigate
 * straight to Messages as before.
 */
export const NetworkMessageButton = ({ professional }: NetworkMessageButtonProps) => {
  const navigate = useNavigate();
  const isSp = professional.role === 'SERVICE_PROVIDER';
  const { launch, modal } = useSpMessageLaunch({
    serviceProviderId: professional.providerId ?? '',
    providerName: professional.companyName,
    sourceSurface: 'my_network',
  });

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (isSp) {
      if (!professional.providerId) {
        console.error('No provider ID available for messaging');
        return;
      }
      void launch();
      return;
    }
    navigate(`/messages?recipientUserId=${professional.targetUserId}`);
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="gap-2 text-gray-600 hover:text-[#026857] hover:bg-[#026857]/10"
        onClick={handleClick}
        title="Message professional"
      >
        <Mail className="w-4 h-4" />
      </Button>
      {isSp && modal}
    </>
  );
};
